document.addEventListener('submit', e => {
	const question = (<HTMLElement>e.target).closest<HTMLFormElement>('form#question');
	if (!question) {
		return
	}
	e.preventDefault();
	if (!question.reportValidity()) {
		return
	}

	sendNotification(question)
		.catch(console.error)
});

document.addEventListener('submit', e => {
	const mail = (<HTMLElement>e.target).closest<HTMLFormElement>('form#mail');
	if (!mail) {
		return
	}
	e.preventDefault();
	if (!mail.reportValidity()) {
		return
	}

	sendNotification(mail)
		.catch(console.error)
});

async function sendNotification(form: HTMLFormElement) {
	const formData = new FormData(form);
	const res = await fetch(`/result/${form.dataset.reportId}/notification`, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
		},
		body: JSON.stringify({
			subject: formData.get('objet')?.toString(),
			BHM7Vo: formData.get('BHM7Vo')?.toString(),
			email: formData.get('email')?.toString(),
			contact: formData.get('contact')?.toString(),
			timestamp: parseInt(formData.get('timestamp')?.toString() ?? '0'),
			mailto: formData.get('mailto')?.toString(),
			txKPav: formData.get('txKPav')?.toString(),
			num: formData.get("num")?.toString(),
			category: formData.get("cat_title")?.toString(),
			type: formData.get("q_or_s")?.toString(),
		}),
	});

	const response = await res.json();

	const targetClass = response.error ? 'if-error' : "if-success";
	for (let child of Array.from(form.children)) {
		if (child instanceof HTMLElement && child.classList.contains(targetClass)) {
			child.style.display = '';
		} else {
			child.remove();
		}
	}

	const $message = document.querySelector('[data-message]');
	if ($message instanceof HTMLElement && response.error) {
		$message.textContent = response.error;
	}
}
